module.exports = __webpack_public_path__ + "img/124-Gris Anthracite SFTN Mat.jpg";